import { formatDuration } from "@/lib/format";

const ORDER = ["booked", "in_progress", "awaiting_approval", "awaiting_parts", "qc", "ready", "delivered"];

const COLORS = {
    booked: "bg-zinc-300 dark:bg-zinc-700",
    in_progress: "bg-sky-500",
    awaiting_approval: "bg-violet-500",
    awaiting_parts: "bg-blue-500",       // info state
    qc: "bg-indigo-500",
    ready: "bg-emerald-500",
    delivered: "bg-emerald-700",
    cancelled: "bg-rose-500",
};

const LABELS = {
    booked: "Booked", in_progress: "In progress", awaiting_approval: "Approval",
    awaiting_parts: "Parts", qc: "QC", ready: "Ready", delivered: "Delivered", cancelled: "Cancelled",
};

export function TATBar({ byStage = {}, current, liveSeconds = 0, total = 0 }) {
    // Build a merged map with live seconds added to the current stage
    const merged = { ...byStage };
    if (current && current !== "delivered" && current !== "cancelled") {
        merged[current] = (Number(byStage[current]) || 0) + (Number(liveSeconds) || 0);
    }
    const totalSecs = Object.values(merged).reduce((a, b) => a + (Number(b) || 0), 0) || total || 1;
    const stages = ORDER.filter((s) => (merged[s] || 0) > 0);

    return (
        <div className="space-y-2" data-testid="tat-bar">
            <div className="flex h-3 w-full overflow-hidden rounded-full bg-zinc-100 dark:bg-zinc-800">
                {stages.map((s) => {
                    const pct = ((merged[s] || 0) / totalSecs) * 100;
                    return (
                        <div
                            key={s}
                            title={`${LABELS[s]} · ${formatDuration(merged[s])}`}
                            className={`${COLORS[s] || "bg-zinc-300"} ${s === current ? "ring-2 ring-brand-red ring-inset" : ""}`}
                            style={{ width: `${pct}%` }}
                            data-testid={`tat-seg-${s}`}
                        />
                    );
                })}
            </div>
            <ul className="grid grid-cols-2 gap-1 text-[11px] sm:grid-cols-3 md:grid-cols-4">
                {stages.map((s) => (
                    <li key={s} className="flex items-center gap-1.5">
                        <span className={`h-2 w-2 shrink-0 rounded-sm ${COLORS[s] || "bg-zinc-300"}`} />
                        <span className="font-mono text-zinc-500">{LABELS[s]}</span>
                        <span className="ml-auto font-mono tabular-nums">{formatDuration(merged[s])}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
